import { render, staticRenderFns } from "./payment-cancel-page.vue?vue&type=template&id=2f4d55fc&scoped=true&"
import script from "./payment-cancel-page.vue?vue&type=script&lang=ts&"
export * from "./payment-cancel-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4d55fc",
  null
  
)

export default component.exports